<div *ngIf="documents.length" class="uploaded-files row">
  <div *ngFor="let file of documents" class="card bg-white col-xs-2 col-sm-3 mx-3">
    <div class="card-body text-center" placement="top" ngbTooltip="{{ file.name }}">
      <i class="fas fa-file-alt fa-3x card-title"></i>
      <div class="card-text">{{ file.name }}</div>
    </div>
  </div>
</div>
